import styled from 'styled-components';
import tw from 'twin.macro';
import { Meta, Body } from '../../styled components/Typography';

export const SchedulesContainer = styled.div(() => [tw`p-16 bg-white`]);
export const SchedulesTable = styled.table(() => [`width: auto;`]);

export const Timeslot = styled(Body)(() => [tw`flex flex-col items-center mt-8 mx-4 px-2`]);
export const TimeslotBullet = styled.span(({ $active, $start }) => [
  tw`rounded-full w-4 h-4`,
  $start && tw`mb-4`,
  $active ? tw`bg-red-darken-10` : tw`bg-gray-lighten-10`
]);

export const ScheduleDateDividerContainer = styled.div(() => [tw`relative pt-8 pb-8`]);
export const ScheduleDateText = styled(Meta).attrs(() => ({
  as: 'p',
  $color: 'gray light'
}))(() => [`margin-top: -.625rem;`, tw`bg-white absolute pl-4 pr-4`]);

export const ScheduleItem = styled(Body).attrs(({ $isDefaultScheduleTime }) => ({
  as: 'tr',
  $textStyle: $isDefaultScheduleTime ? `bold` : `default`
}))(() => [tw`align-top`]);
export const ScheduleItemBullet = styled.td(() => [tw`align-top p-0`]);
export const ScheduleItemTime = styled.td(() => [tw`text-right pr-8 tabular-nums text-nowrap`]);
export const ScheduleItemDescription = styled.td(() => [tw`w-full`]);
